<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.slides)) {
        this.$set(this.form, 'slides', [])
      }
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Automatyczna rotacja',
              modelPath: [this, 'form', 'is_auto']
            }),
            new fields.Input({
              label: 'Interwał (ms)',
              modelPath: [this, 'form', 'interval'],
              disabled: !this.form.is_auto,
              type: 'number'
            }),
            new fields.Header({
              type: 'h3',
              text: 'Slajdy'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'slides'],
              items: this.form.slides.map((itemSlide, i) => {
                return {
                  headerLabel: itemSlide.title_pl,
                  fields: [
                    new fields.Input({
                      label: 'Tytuł',
                      modelPath: [this, 'form', 'slides', i, 'title'],
                      multilingual: true,
                      required: true
                    }),
                    new fields.Date({
                      label: 'Pierwsza data',
                      modelPath: [this, 'form', 'slides', i, 'first_date'],
                      format: 'yyyy-MM-dd',
                      valueFormat: 'yyyy-MM-dd',
                      required: true
                    }),
                    new fields.Date({
                      label: 'Ostatnia data',
                      modelPath: [this, 'form', 'slides', i, 'last_date'],
                      format: 'yyyy-MM-dd',
                      valueFormat: 'yyyy-MM-dd'
                    }),
                    new fields.Input({
                      label: 'Link do YouTube',
                      modelPath: [this, 'form', 'slides', i, 'youtube_url'],
                      format: 'yyyy-MM-dd'
                    }),
                    new fields.Image({
                      label: 'Zdjęcie',
                      modelPath: [this, 'form', 'slides', i, 'image'],
                      required: true
                    }),
                    new fields.Link({
                      label: 'Link przycisku',
                      modelPath: [this, 'form', 'slides', i, 'button_link'],
                      required: true
                    }),
                    new fields.Link({
                      label: 'Dodatkowy link (z ikonką)',
                      modelPath: [this, 'form', 'slides', i, 'ticket_link']
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
